import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function StatsBar() {
  const revealRef = useScrollReveal();
  const stats = [{
    number: '+500',
    label: 'Lectores transformados'
  }, {
    number: '4.9★',
    label: 'Valoración promedio'
  }, {
    number: '100+',
    label: 'Páginas de protocolo'
  }, {
    number: '7 días',
    label: 'Garantía total'
  }];
  return <section className="bg-brand-gold w-full" data-id="element-184">
      <div ref={revealRef} className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 reveal" data-id="element-185">
        {stats.map((stat, i) => <div key={i} className="text-center py-7 px-4 border-b md:border-b-0 md:border-r border-brand-dark/10 last:border-0" data-id="element-186">
            <div className="font-display text-[46px] text-brand-dark font-normal leading-none mb-1" data-id="element-187">
              {stat.number}
            </div>
            <div className="font-body text-[12px] text-brand-dark/60 tracking-[0.04em] uppercase" data-id="element-188">
              {stat.label}
            </div>
          </div>)}
      </div>
    </section>;
}